import { Component, OnInit, forwardRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { 
    
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { DemoozModalMediaComponent, DemoozButtonComponent } from '@demooz/components';
import { DataService } from '@app/services';
import { OperationFaq } from '@app/models';

class FaqMedia {
    src: string;
    type: 'picture'|'video';
    constructor(src: string, type: 'picture'|'video'){
        this.src = src;
        this.type = type;
    }
}

@Component({
    selector: 'app-faq-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.scss'],
    imports: [
        TranslatePipe, forwardRef(() => DemoozModalMediaComponent), forwardRef(() => DemoozButtonComponent)
    ]
})
export class FaqDetailsComponent  implements OnInit {
      
    @Input({alias : 'faq', required : true}) faq: OperationFaq;
        
    @ViewChild('modalMedia') modalMedia: DemoozModalMediaComponent;
           
    description: SafeHtml;
    faqMedia: FaqMedia|null = null;
    
    constructor(     
        private domSanitizer: DomSanitizer,
        public translateService: TranslateService,
        public dataService: DataService
    ) { }

    ngOnInit() {
        
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['faq'] && changes['faq'].currentValue){
            this.initFaqDetails();
        }
    }
    
    initFaqDetails(){
        this.description = this.domSanitizer.bypassSecurityTrustHtml(this.faq.description);
        let faqMedia: FaqMedia|null = null;
        if(this.faq.media && this.faq.media != ''){
            let mediaType: 'picture'|'video'|null = null;;
            let temp = this.faq.media.split('.');                
            if(temp.length > 0){
                let ext = temp[temp.length-1].toLowerCase();
                if(['mp4'].indexOf(ext) !== -1){
                    mediaType = 'video';
                }
                else if(['png','jpg', 'jpeg', 'gif'].indexOf(ext) !== -1){
                    mediaType = 'picture';
                }
            }  
            if(mediaType !== null){
                faqMedia = new FaqMedia(this.faq.media, mediaType);
            }
        }
        this.faqMedia = faqMedia;
    }
    
    showMedia(){
        this.modalMedia.open(this.faq.media);
    }
    
    openLinkFaq(){
        if(this.faq.buttonLink && this.faq.buttonLink != ''){
            let link = document.createElement('a');
            link.href = this.faq.buttonLink;
            link.target = '_blank';
            link.click();
        }    
    }
}
